'use client'

// Containers — the nest roosts. containers_mat.glb now bakes ALL four clusters
// at their world positions (4 clusters x 3 containers = 12 meshes), so a single
// mount paints every nest; there's no per-nest placement any more. We swap the
// GLB's standard materials for the app's node materials (so the palette + dither
// pipeline applies) and make them double-sided, so the open container reads its
// interior where Victor roosts (harmless on the closed ones).

import { useMemo } from 'react'
import * as THREE from 'three/webgpu'
import { useModel } from '../hooks/useModel'
import { useNodeMaterials } from '../hooks/useNodeMaterials'

export function Containers(props) {
  const { scene, materials } = useModel('/models/containers_mat.glb')
  const { nodeMats, getMat } = useNodeMaterials(materials)

  const object = useMemo(() => {
    for (const m of Object.values(nodeMats)) m.side = THREE.DoubleSide
    // Clone so the shared cached GLB scene isn't mutated (materials/geometry
    // stay shared by reference, which is what we want).
    const s = scene.clone(true)
    s.traverse((o) => {
      if (!o.isMesh) return
      o.material = getMat(o)
      o.castShadow = true
      o.receiveShadow = true
    })
    return s
  }, [scene, nodeMats, getMat])

  return <primitive object={object} {...props} dispose={null} />
}
